import React from 'react';
import { useTranslation } from 'react-i18next';

import { ActionButton } from '../../../common/petCloud';

import '../css/ReimbursementEditModal.css';

const EditReimbursementModalButtons = ({
  handleEditReimbursementAccept = () => { },
  handleEditReimbursementCancel = () => { },
  handleEditReimbursementSuccess = () => { },
  isFormInvalid = false,
  reimbursementMethodUpdateSuccess = false,
  updatingReimbursementMethod = false,
  finalStep = false,
  customAcceptLabel = '',
}) => {
  const { t } = useTranslation('common');

  return (
    <div className="Reimbursement-edit-modal-footer-buttons-container">
      <ActionButton
        disabled={updatingReimbursementMethod}
        isSecondaryButton
        onClick={handleEditReimbursementCancel}
        title={t('backButton')}
      />

      <ActionButton
        disabled={isFormInvalid}
        loading={updatingReimbursementMethod}
        onClick={handleEditReimbursementAccept}
        onSuccess={handleEditReimbursementSuccess}
        success={reimbursementMethodUpdateSuccess}
        title={customAcceptLabel || (finalStep
          ? t('saveButton')
          : t('next'))}
      />
    </div>
  );
};

export { EditReimbursementModalButtons };
